// import XLSX from 'xlsx';
import XLSX from "../../node_modules/xlsx/xlsx.js";
const workbook2blob = function (workbook) {
  // 生成excel的配置项
  var wopts = {
    // 要生成的文件类型
    bookType: 'xls',
    // // 是否生成Shared String Table，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
    bookSST: false,
    type: 'binary'
  }
  var wbout = XLSX.write(workbook, wopts)
  // 将字符串转ArrayBuffer
  function s2ab(s) {
    var buf = new ArrayBuffer(s.length)
    var view = new Uint8Array(buf)
    for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
    return buf
  }
  let buf = s2ab(wbout)
  var blob = new Blob([buf], {
    type: 'application/octet-stream'
  })
  return blob
}

// 将blob对象 创建bloburl,然后用a标签实现弹出下载框
const openDownloadDialog = function (blob, fileName) {
  if (typeof blob === 'object' && blob instanceof Blob) {
    blob = URL.createObjectURL(blob) // 创建blob地址
    console.log(blob);
  }
  var aLink = document.createElement('a')
  aLink.href = blob
  // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，有时候 file:///模式下不会生效
  /* eslint-disable */
  aLink.download = fileName ? fileName : '';
  var event
  if (window.MouseEvent) event = new MouseEvent('click')
  //   移动端
  else {
    event = document.createEvent('MouseEvents')
    // event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
    event.dispatchEvent('click');
  }
  aLink.dispatchEvent(event)
}
/* exportBtn () {
  this.exportExcel()
} */
const exportExcel = function (data, exname) {

  var sheet = XLSX.utils.json_to_sheet(data)
  // 创建一个新的空的workbook
  var wb = XLSX.utils.book_new();
  console.log(wb);
  console.log(exname);
  XLSX.utils.book_append_sheet(wb, sheet, 'sheet1')
  const workbookBlob = workbook2blob(wb)
  openDownloadDialog(workbookBlob, exname ? exname : "模板.xls")
}
export { exportExcel, openDownloadDialog, workbook2blob }